var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3152_144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1281 64H86.7281V82.048L102.344 91.072L97.5441 99.392L77.1281 87.616V64ZM13.1281 0H102.728C106.123 0 109.379 1.34857 111.779 3.74903C114.179 6.1495 115.528 9.40523 115.528 12.8V51.84C123.464 59.904 128.328 70.976 128.328 83.2C128.328 95.0817 123.608 106.477 115.206 114.878C106.805 123.28 95.4098 128 83.5281 128C71.3041 128 60.2321 123.136 52.1681 115.2H13.1281C9.73336 115.2 6.47763 113.851 4.07716 111.451C1.6767 109.051 0.328125 105.795 0.328125 102.4V12.8C0.328125 9.40523 1.6767 6.1495 4.07716 3.74903C6.47763 1.34857 9.73336 0 13.1281 0ZM13.1281 83.2V102.4H43.0161C40.2641 96.576 38.7281 90.048 38.7281 83.2H13.1281ZM13.1281 38.4H51.5281V19.2H13.1281V38.4ZM102.728 38.4V19.2H64.3281V38.4H102.728ZM13.1281 70.4H40.5841C42.7601 63.04 46.7921 56.448 52.1681 51.2H13.1281V70.4ZM83.5281 52.16C75.2958 52.16 67.4006 55.4303 61.5795 61.2514C55.7584 67.0725 52.4881 74.9677 52.4881 83.2C52.4881 100.352 66.3761 114.24 83.5281 114.24C87.6043 114.24 91.6406 113.437 95.4066 111.877C99.1725 110.317 102.594 108.031 105.477 105.149C108.359 102.266 110.645 98.8444 112.205 95.0785C113.765 91.3125 114.568 87.2762 114.568 83.2C114.568 66.048 100.68 52.16 83.5281 52.16Z",
    fill: "#172B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3152_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0.328125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.de5252a7a8dce370b4b592019eed79f5.svg";
export { ForwardRef as ReactComponent };